import { useForgotPasswordForm } from '../../../../../hooks/useForgotPasswordForm';
import NeobetAuthFormShell from '../../auth/NeobetAuthFormShell';
import { NeobetTextField } from '../../molecules/NeobetFormFields';
import TurnstileChallenge from '../../../../shared/TurnstileChallenge';

const NeobetForgotPasswordForm = () => {
  const { t, control, errors, isSubmitting, handleClose, onSubmit, turnstile } = useForgotPasswordForm();

  return (
    <div data-testid='neobet-forgot-password-form'>
      <NeobetAuthFormShell
        title={t('forgotPassword.title')}
        submitTitle={t('forgotPassword.sendResetLink')}
        onSubmit={onSubmit}
        onClose={handleClose}
        isSubmitting={isSubmitting}
        submitDisabled={!turnstile.isReady}
        testId='neobet-forgot-password-form'
      >
        <NeobetTextField
          name='email'
          control={control}
          label={t('register.email')}
          error={!!errors.email}
          helperText={errors.email?.message}
          disabled={isSubmitting}
        />
        <TurnstileChallenge {...turnstile.widgetProps} />
      </NeobetAuthFormShell>
    </div>
  );
};

export default NeobetForgotPasswordForm;
